import React, {useEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import endpointList from "../../config/endpointList.jsx";
import "swiper/css";
import { Navigation } from "swiper/modules";
import mright from "../../assets/icons/icon-mright.svg";
import downsm from "../../assets/icons/icon-downsm.svg";
import { setCanvasLoaded } from "../../Store/reducers/waitTextureSlice.js";
import { fetchColors } from "../../Store/reducers/colorSlice.js";
import { fetchMockupCategories, setSelectedMockup, fetchMockups } from "../../Store/reducers/mockupCategorySlice.js";
import AppConfig from "../../config/AppConfig";
import FullCategoryMockups from "./Mockups/FullCategoryMockups.jsx";
import { GrFormCheckmark } from "react-icons/gr";
import { saveState } from '../../Store/reducers/fabriccontrolsSlice.js';
const ColorFilter = ({
                         colors,
                         expandedColors,
                         toggleExpandedColors,
                         selectedColor,
                         onColorClick,
                         onRemoveFilter,
                     }) => {
    const displayColors = expandedColors ? colors : colors.slice(0, 8);

    return (
        <div className="mb-6 border-b border-gray-300 px-4 py-1">
            <h2 className="font-semibold mb-2 text-black text-[12px]">
                Filter by Color
            </h2>
            <div className="grid grid-cols-8 gap-2">
                {displayColors.map((color, index) => (
                    <div
                        key={index}
                        className={`relative w-[25px] h-[24px] rounded cursor-pointer ${
                            selectedColor === color.id ? "border-2 border-bg-[#8d8e8f]" : ""
                        }`}
                         
                        style={{ backgroundColor: color.color }}
                        onClick={() => onColorClick(color)}
                    >
                        {selectedColor === color.id && (
                            <div className="absolute inset-0 flex items-center justify-center">
                                <span className="text-white text-[14px]  font-bold">
                                <GrFormCheckmark className="text-[#8d8e8f] text-[25px]" />
                                </span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="flex justify-between items-center mt-2 text-gray-500">
                {colors.length > 8 && (
                    <div
                        className="flex items-center gap-[1px] cursor-pointer"
                        onClick={toggleExpandedColors}
                    >
                        <img
                            src={downsm}
                            alt="Expand Colors"
                            className={`w-[11px] h-[10px] transition-transform duration-700 ease-in-out transform ${
                                expandedColors ? "rotate-180" : "rotate-0"
                            }`}
                        />
                        <button className="font-semibold text-black text-[11px]">
                            {expandedColors ? "See Less" : "See More"}
                        </button>
                    </div>
                )}
                <button
                    className="font-semibold text-black text-[11px]"
                    onClick={onRemoveFilter}
                >
                    Remove Filter
                </button>
            </div>
        </div>
    );
};

const MockupGroup = ({ mockup, expanded, setSwipers, handleNextSlide,handlePrevSlide, setSelectedCategory, selectedColor,handleAddMockupToCanvas }) => {
    const hasManyItems = mockup.mockups.length > 2;
    const isExpanded = expanded[mockup.id];
    const dispatch = useDispatch();
    const [currentSlide, setCurrentSlide] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const prevSlideRef = useRef(currentSlide);


    useEffect(() => {
        if (currentSlide % 13 === 0 && currentSlide !== 0 && currentSlide > prevSlideRef.current) {
            setCurrentSlide(0);
            setCurrentPage((prevPage) => prevPage + 1);
            dispatch(fetchMockups({ page: currentPage + 1, categoryId: mockup.id }));
        }
        prevSlideRef.current = currentSlide;
    }, [currentSlide]);


    const filteredItems = selectedColor
    ? mockup.mockups.filter(
        (item) => item.color_id === selectedColor
      )
    : mockup.mockups;



  if (selectedColor && filteredItems.length === 0) {
    return (
      <div className="mb-5">
        <h3 className="font-semibold text-black font-montserrat text-[12px] leading-[12.19px]">
          {mockup.title}
        </h3>
        <p className="text-gray-500 text-[12px]">No mockups available in this color.</p>
      </div>
    );
  }

    return (
        <div className="mb-5">
            <div className="flex justify-between w-[88%]">
                <h3 className="font-semibold text-black font-montserrat text-[12px] leading-[12.19px]">
                    {mockup.title}
                </h3>
                {hasManyItems && (
                    <button
                        className="font-semibold text-black font-montserrat text-[11px] leading-[12.19px]"
                        onClick={() => {
                            setSelectedCategory(mockup)
                        }}
                    >
                        {isExpanded ? "Show Less" : "Show All"}
                    </button>
                )}
            </div>
            {hasManyItems && !isExpanded ? (
                <div className="flex items-center justify-center mt-2">
                    <img
                        src={mright}
                        alt="Next Icon"
                        className="w-[20px] h-[20px] cursor-pointer rotate-180"
                        onClick={() => handlePrevSlide(mockup.id)}
                    />
                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={25}
                        slidesPerView={filteredItems.length > 1 ? 2 : 1}
                        navigation={false}
                        loop={false}
                        allowTouchMove={false}
                        onSwiper={(swiper) =>
                            setSwipers((prev) => ({
                                ...prev,
                                [mockup.id]: swiper,
                            }))
                        }
                        onSlideChange={(swiper) => {
                            setCurrentSlide(swiper.activeIndex);
                        }}
                    >
                        {filteredItems.map((item, index) => (
                            <SwiperSlide key={index}>
                                <img
                                     onClick={() => {
                                        dispatch(setCanvasLoaded(false)); 
                                        handleAddMockupToCanvas(item);
                                      }}
                                    src={`${AppConfig.storageUrl}/${item.mockup}`}
                                    className="w-[90px] h-[90px] object-cover"
                                    draggable
                                    alt=""
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <img
                        src={mright}
                        alt="Next Icon"
                        className="w-[20px] h-[20px] cursor-pointer"
                        onClick={() => handleNextSlide(mockup.id)}
                    />
                </div>
            ) : (
                <div className="grid grid-cols-2 gap-1 mt-2">
                    {filteredItems.map((item, index) => (
                        <img
                            onClick={() => handleAddMockupToCanvas(item)}
                            key={index}
                            src={`${AppConfig.storageUrl}/${item.mockup}`}
                            className="w-[90px] h-[90px] object-cover"
                            draggable
                            alt=""
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

const Mockup = ({ searchQuery }) => {
    const activeTab = useSelector((state) => state.activeTab.activeTab);
    const storedColors = useSelector((state) => state.colors.Colors) || [];
    const storedMockups = useSelector((state) => state.mockupCategories.Mockups) || [];
    const selectedMockup = useSelector((state) => state.mockupCategories.selectedMockup) || [];
    const canvasesState = useSelector((state) => state.canvasesstate.canvases);

    
    const dispatch = useDispatch();

    const [swipers, setSwipers] = useState({});
    const [expandedColors, setExpandedColors] = useState(false);
    const [selectedColor, setSelectedColor] = useState(null);
    const [expanded, setExpanded] = useState({});
    const observerRef = useRef(null);
    const [selectedCategory, setSelectedCategory] = useState(null)

    const handleAddMockupToCanvas = (item) => {
        const { storageUrl } = AppConfig;

        const selectedMockup = {
            design_layer: `${storageUrl}/${item.mockup}`,
            glb_layer: `${storageUrl}/${item.glb_layer}`,
            mask_layer: `${storageUrl}/${item.design_layer}`,
            height: item.height,
            width: item.width,
            ...(item.shadow_layer != null && { shadow_layer: `${storageUrl}/${item.shadow_layer}` }),
            ...(item.additional_layer != null && { additional_layer: `${storageUrl}/${item.additional_layer}` }),
            logoDefaultSize: item.default_size,
            logoMinSize: item.min_size,
            logoMaxSize: item.max_size,
            logoBoundaryX1: item.boundary_x1,
            logoBoundaryX2: item.boundary_x2,
            logoBoundaryY1: item.boundary_y1,
            logoBoundaryY2: item.boundary_y2,
        };
        dispatch(setSelectedMockup(selectedMockup));
        const savedString = canvasesState.previewMockupCanvasState?.currentState;
        let local = {};                             

          if (savedString) {
        try {
         local = JSON.parse(savedString);

     
          local.textDesign = null;
         } catch (err) {
         console.warn("Could not parse saved canvas state:", err);
          local = {};
         }
      }
  dispatch(saveState({
    tab: "previewMockupCanvasState",
    canvasState: JSON.stringify(local)
  }));
};

    useEffect(() => {
        if (!storedColors.length) {
            dispatch(fetchColors());
        }
    }, [storedColors]);

    useEffect(() => {
        const getDefaultMockup = async () => {

           const searchParams = new  URLSearchParams(window.location.search);
           const mockupId = searchParams.get("mockup_id")

           if (!mockupId || Object.keys(selectedMockup)?.length !== 0 ) {
               console.error("No mockup_id found in URL");
               return;
             }

             const url = `${endpointList.getMockup}/${mockupId}`;

             try {
               const response = await fetch(url);

               const mockupResponse = await response.json();
               handleAddMockupToCanvas(mockupResponse.data)
               console.log("Fetched mockup:", mockupResponse);
             } catch (err) {
               console.error("Failed to fetch mockup:", err);
             }
        };

        getDefaultMockup();
},[])

    useEffect(() => {
        if (!storedMockups.length) {
            dispatch(fetchMockupCategories({searchQuery:searchQuery}));
        }
    }, [storedMockups]);

    useEffect(()=> {
        
        dispatch(fetchMockupCategories({searchQuery:searchQuery}));
    },[searchQuery])

    const handleNextSlide = (id) => {
        if (swipers[id]) {
            swipers[id].slideNext();
        }
    };
    const handlePrevSlide = (id) => {
        if (swipers[id]) {
            swipers[id].slidePrev();
        }
    };
    const toggleExpandedColors = () => {
        setExpandedColors((prev) => !prev);
    };

    const handleColorClick = (color) => {
        setSelectedColor((prev) => (prev === color.id ? null : color.id));
    };

    const handleRemoveFilter = () => {
        setSelectedColor(null);
    };
    return (
        <>
            {activeTab === "previewMockup" && (
                <div>
                    <ColorFilter
                        colors={storedColors}
                        expandedColors={expandedColors}
                        toggleExpandedColors={toggleExpandedColors}
                        selectedColor={selectedColor}
                        onColorClick={handleColorClick}
                        onRemoveFilter={handleRemoveFilter}
                    />

                  {
                      selectedCategory ?
                          <FullCategoryMockups categoryId={selectedCategory.id}
                                               setSelectedCategory={setSelectedCategory}/> :
                          <div className="h-[340px] overflow-y-scroll custom-scrollbar px-3" ref={observerRef}>
                              {storedMockups.map((mockup) => (
                                  <MockupGroup
                                      key={mockup.id}
                                      mockup={mockup}
                                      selectedColor={selectedColor}
                                      expanded={expanded}
                                      setSwipers={setSwipers}
                                      handleNextSlide={handleNextSlide}
                                      handlePrevSlide={handlePrevSlide}
                                      setSelectedCategory={setSelectedCategory}
                                      handleAddMockupToCanvas={handleAddMockupToCanvas}

                                  />
                              ))}
                          </div>


                  }
                </div>
            )}
        </>
    );
};

export default Mockup;
